import { CommonModule } from '@angular/common';
import { Component, ViewChild, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'change-password',
    template: `
    <div mat-dialog-content>
      <div class="password-error" *ngIf="errorMessage" [textContent]="errorMessage"></div>
      <form  #passwordForm="ngForm">
        <mat-form-field class="general">
          <input matInput type="password" name="current_password" [(ngModel)]="current_password" placeholder="Current password" required>
        </mat-form-field>
        <mat-form-field class="general">
          <input matInput type="password" name="password" [(ngModel)]="password" minlength="6" placeholder="New password" required>
        </mat-form-field>
        <mat-error *ngIf="passwordForm.controls['password']?.dirty && passwordForm.controls['password']?.errors?.minlength">
          Password must be at least 6 characters
        </mat-error>
        <mat-form-field class="general">
          <input matInput type="password" name="conf_password" [(ngModel)]="conf_password" placeholder="Confirm new password" required>
        </mat-form-field>
        <mat-error *ngIf="passwordForm.controls['conf_password']?.dirty && (passwordForm.controls['password']?.value != passwordForm.controls['conf_password']?.value)">
          Passwords do not match
        </mat-error>
      </form>
    </div>
  `,
    styles: [`
  .password-error { color: #f05454; border: 1px solid #f05454; font-size: 1.2em; margin: -15px 0px 20px; padding: 15px 10px; border-radius: 6px;}
  .joi-dialog.small .title4 { font-size:14px; font-weight:bold; line-height: 22px; }
  .joi-dialog.small .para { font-size:14px; line-height: 22px; }
  @media screen and (max-width: 768px) { .cdk-overlay-pane { margin: auto !important } }
  `],
    styleUrls: [`../modules/accounts/profile.scss`],
    standalone: true,
    imports: [MatFormFieldModule, CommonModule, ReactiveFormsModule, FormsModule]
})
export class ChangePasswordComponent {
  @Input() errorMessage
  current_password
  password
  conf_password

  @ViewChild('passwordForm', { static: true }) passwordForm;
  constructor() { }
}